export default function Logo({ size = 36 }) {
  const rings = [];
  for (let ring = 0; ring < 3; ring++) {
    const r = 30 + ring * 10;
    const count = 16 + ring * 6;
    const dotSize = 3.2 - ring * 0.4;
    const opacity = 0.7 + ring * 0.15;
    for (let i = 0; i < count; i++) {
      const a = (2 * Math.PI * i) / count - Math.PI / 2;
      rings.push(
        <circle
          key={`${ring}-${i}`}
          cx={50 + r * Math.cos(a)}
          cy={50 + r * Math.sin(a)}
          r={dotSize}
          fill="#2ec4b6"
          opacity={opacity}
        />
      );
    }
  }

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      {rings}
    </svg>
  );
}
